// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-icon{width:auto !important;height:auto !important;color:inherit}.czt-icon>svg{width:1em !important;height:1em !important;font-size:inherit}.czt-icon.v-icon[class*=czt-icon]{color:inherit}.czt-icon--bordered{border:2px solid currentColor;border-radius:50%}", ""]);
// Exports
module.exports = exports;
